import { Component, OnInit, ViewChild } from '@angular/core';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { FormsModule } from '@angular/forms';
import { CalendarOptions } from '@fullcalendar/core';
import { FullCalendarComponent, FullCalendarModule } from '@fullcalendar/angular';
import dayGridPlugin from '@fullcalendar/daygrid';
import { DialogModule } from 'primeng/dialog';
import { Router } from '@angular/router';

import { PropertyService } from '../properties/service/property.service';
import { CommonModule } from '@angular/common';
import moment from 'moment';
import { SharedModule } from '../../core/shared/shared.module';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CardModule, ButtonModule, CalendarModule, FormsModule, FullCalendarModule, DialogModule, CommonModule, SharedModule],
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  dateRange: Date[] = [
    new Date(new Date().getFullYear(), new Date().getMonth(), 1), 
    new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
  ];
  followUpsSummary: any = null;
  pipelineStatuses = [
    { title: 'Leads', key: 'leads' },
    { title: 'Scheduled', key: 'active' },
    { title: 'Complete', key: 'complete' },
  ];

  calendarOptions: CalendarOptions = {
    plugins: [dayGridPlugin],
    initialView: 'dayGridMonth',
    eventClick: (info) => {
      this.handleDateClick(info);
    },
    eventTimeFormat: {
      hour: '2-digit',
      minute: '2-digit',
      meridiem: true,
      hour12: true,
    },
    weekends: true,
    events: [],
  };
  displayModal: boolean = false;
  meetingDetails: any = {};
  userInfo: any = null;
  propTimeZone: string = '';
  constructor(private propertyService: PropertyService, private router: Router) {}

  ngOnInit(): void {
    this.propertyService.getUserInfo().subscribe(user => {
      this.userInfo = user;
      if (user?.user_type === 'tenant') {
        this.router.navigate(['/tenants-portal']);
        return;
      }
      this.propTimeZone = this.userInfo.property.timezone;
      this.calendarOptions = {
        ...this.calendarOptions,
        timeZone: this.propTimeZone
      };
      this.getAllFollowups();
    })
  }

  loadCalendarEvents(): void {
      const events = this.followUpsSummary.topRecords.active.map((event: any) => {
        let start = moment.tz(`${event.date} ${event.time}`, ['MM/DD/YYYY h A','MM/DD/YYYY h:mm A'], 'UTC').tz(this.propTimeZone).format('YYYY-MM-DD HH:mm');
        console.log('start', start)
        let start2 = moment.tz(event.planned_date, 'YYYY-MM-DD HH:mm', 'UTC').tz(this.propTimeZone).format("YYYY-MM-DD hh:mm");
        console.log('start2', start2)
        let end_time = this.getEndTime(event?.planned_date);
        return {
          title: event.customer_name || '',
          start: start,
          end: end_time,
          description: event.property_name || '',
          uri: this.propTimeZone,
          id:event._id
        }
      });
      this.calendarOptions.events = events;
      console.log('calendarOptions', this.calendarOptions.events)
  }

  getAllFollowups(): void {
    const [startDate, endDate] = this.dateRange as any;
    if(!startDate || !endDate || startDate==='Invalid date' || endDate==='Invalid date'){
      return;
    }
    this.propertyService.getFollowUpsSummary(startDate, endDate).subscribe({
      next: (res) => {
        this.followUpsSummary = res
        this.loadCalendarEvents();
      },
      error: (err) => console.error('Error fetching followUps', err),
    });
  }

  handleDateClick(info: any): void {
    const detail = this.followUpsSummary.topRecords.active.find((x: any) => x._id === info?.event?.id);
    if(detail){
      this.meetingDetails = {
        title: detail.property_name,
        start: `${detail?.date} ${detail?.time}`,
        end: this.getEndTime(detail?.planned_date),
        name: detail?.customer_name,
        email: detail?.customer_email,
        customerPhone:detail?.phone_number,
        propertyName:detail?.property_name,
        plan:detail?.plan_name,
        location: detail.property_name,
        agentName:detail?.user_name,
      };
      this.displayModal = true;
    }
  }

  onDateRangeChange(): void {
    this.getAllFollowups();
  }

  getEndTime(planned_date: string) {
    let time = moment.tz(planned_date, 'YYYY-MM-DD HH:mm', 'UTC').tz(this.propTimeZone)
    time.add(30, 'minutes');
    return time.format("YYYY-MM-DD hh:mm A")
  }
}
